import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';

export default function AdminLogin() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  useEffect(() => {
    if (localStorage.getItem('adminToken')) navigate('/admin/dashboard');
  }, [navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { data } = await axios.post('/api/admin/login', { username, password });
      localStorage.setItem('adminToken', data.token);
      localStorage.setItem('adminUser',  data.username);
      navigate('/admin/dashboard');
    } catch {
      setError(t('admin.invalidCreds'));
      setLoading(false);
    }
  }

  return (
    <>
      <Navbar />
      <section className="min-vh-100 d-flex align-items-center bg-festival">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-sm-8 col-md-6 col-lg-4">
              <div className="card border-0 shadow-lg rounded-4 p-4 p-lg-5">
                <div className="text-center mb-4">
                  <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{ width: 64, height: 64, background: 'linear-gradient(135deg, var(--primary), var(--secondary))' }}>
                    <i className="bi bi-shield-lock-fill text-white fs-3" />
                  </div>
                  <h4 className="fw-bold mb-1">{t('admin.loginTitle')}</h4>
                  <p className="text-muted small">Glocal Festival Admin</p>
                </div>

                {error && (
                  <div className="alert alert-danger rounded-3 py-2 small mb-3">
                    <i className="bi bi-exclamation-triangle me-2" />{error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label fw-semibold small">{t('admin.username')}</label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-end-0">
                        <i className="bi bi-person text-muted" />
                      </span>
                      <input
                        type="text"
                        className="form-control border-start-0"
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                        required
                        autoFocus
                      />
                    </div>
                  </div>
                  <div className="mb-4">
                    <label className="form-label fw-semibold small">{t('admin.password')}</label>
                    <div className="input-group">
                      <span className="input-group-text bg-light border-end-0">
                        <i className="bi bi-lock text-muted" />
                      </span>
                      <input
                        type="password"
                        className="form-control border-start-0"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <button type="submit" className="btn btn-donate w-100 py-3" disabled={loading}>
                    {loading ? (
                      <><span className="spinner-border spinner-border-sm me-2" />{t('admin.loggingIn')}</>
                    ) : (
                      <><i className="bi bi-box-arrow-in-right me-2" />{t('admin.loginBtn')}</>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
